import dayjs from "dayjs";

// A feed's time line: recent posts by how long ago, older ones by date.
export const feedDate = (
  publishedAt: string,
  now: dayjs.Dayjs = dayjs(),
): string => {
  const days = now
    .startOf("day")
    .diff(dayjs(publishedAt).startOf("day"), "day");
  if (days <= 0) return "Today";
  if (days === 1) return "Yesterday";
  if (days < 7) return `${days} days ago`;
  return dayjs(publishedAt).format("D MMM YYYY");
};
